import React from "react";
import { useKelasLiveContext } from "stores/kelas-live/kelas-live-context";
import { KelasLiveCMBForm } from "./kelas-live-cmb-form/kelas-live-cmb-form";
import { KelasLiveCMBAckModal } from "./kelas-live-cmb-ack-modal/kelas-live-cmb-ack-modal";
import { KelasLiveCMBCTA } from "./kelas-live-cmb-cta/kelas-live-cmb-cta";
import { KelasLiveCMBInfoModal } from "./kelas-live-cmb-info-modal/kelas-live-cmb-info-modal";
import {
  IKelasLiveCallMeBack,
  KelasLiveCMBStages
} from "./kelas-live-cmb.types";
import { useKelasLiveCMB } from "./use-kelas-live-cmb";

const KelasLiveCMB: React.FC<IKelasLiveCallMeBack> = ({
  onGoingClassExists
}) => {
  const {
    user: {
      userData: { primary_user }
    }
  } = useKelasLiveContext();
  const {
    contactKakakSiagaStage,
    setContactKakakSiagaStage,
    phoneNumber,
    requestCallBack,
    showContactKakakSiagaModal,
    setShowContactKakakSiagaModal
  } = useKelasLiveCMB({ primary_user });

  const handleCMBStage = (stage: KelasLiveCMBStages) => {
    setContactKakakSiagaStage(stage);
    setShowContactKakakSiagaModal.on();
  };

  const handleModalClose = () => {
    setShowContactKakakSiagaModal.off();
    setContactKakakSiagaStage(KelasLiveCMBStages.INITIAL_STAGE);
  };

  return (
    <>
      <KelasLiveCMBCTA
        onGoingClassExists={onGoingClassExists}
        handleOnClick={handleCMBStage}
      />

      {showContactKakakSiagaModal &&
        contactKakakSiagaStage === KelasLiveCMBStages.SHOW_INFO_STAGE && (
          <KelasLiveCMBInfoModal
            onGoingClassExists={onGoingClassExists}
            onClose={handleModalClose}
          />
        )}
      {showContactKakakSiagaModal &&
        contactKakakSiagaStage === KelasLiveCMBStages.SHOW_ACK_STAGE && (
          <KelasLiveCMBAckModal
            onClose={handleModalClose}
            handleOnClick={handleCMBStage}
            phoneNumber={phoneNumber}
            primary_user={primary_user}
            onGoingClassExists={onGoingClassExists}
          />
        )}
      {showContactKakakSiagaModal &&
        contactKakakSiagaStage === KelasLiveCMBStages.SHOW_FORM_STAGE && (
          <KelasLiveCMBForm
            onClose={handleModalClose}
            handleOnClick={handleCMBStage}
            requestCallBack={requestCallBack}
          />
        )}
    </>
  );
};

export { KelasLiveCMB };
